import { DEFAULT_LIMIT } from './pagination';

export const DEFAULT_BUILDERS_PROJECTS_DATA = {
  page: 0,
  limit: DEFAULT_LIMIT,
  projectsList: [],
  seo: { regionPrepositional: '' },
  total: 0,
  location: { id: 1, name: 'Россия' },
  breadcrumbs: [],
};
